import * as ko from "knockout";
import {ICompanySyncstep, ICompanySyncstepFilter} from "../../../../../index";
import {ErrorManager} from "../../../../../error/ErrorManager";
import {ObjectTypeId} from "../../../../../constants";
import {MutableSyncstepFilter} from "./MutableSyncstepFilter";
import {IMutableSyncstepFilterParams} from "../../synccycle/export-filter/index";
import {StatusManager} from "../../StatusManager";

export class MutableSyncstepFilters {

    private readonly filters: KnockoutObservableArray<MutableSyncstepFilter> = ko.observableArray();

    constructor(private companySyncstep: ICompanySyncstep, private errorManager: ErrorManager, private statusManager: StatusManager) {
    }

    public init() {
        this.filters().forEach(o => o.dispose())
        const filters = [
            ObjectTypeId.User,
            ObjectTypeId.Department,
            ObjectTypeId.Group,
        ].map(objectTypeId => {
            const filter = this.companySyncstep.filters.find(o => o.objecttypeid == objectTypeId)
            const params: IMutableSyncstepFilterParams = filter
                ? {
                    companySyncstep: this.companySyncstep,
                    errorManager: this.errorManager,
                    filter: filter,
                    isDeleted: false,
                }
                : {
                    companySyncstep: this.companySyncstep,
                    errorManager: this.errorManager,
                    filter: this.createNewFilter(objectTypeId),
                    isDeleted: true,
                }
            return new MutableSyncstepFilter(params)
        })
        this.filters(filters)
    }

    private createNewFilter(objectTypeId: ObjectTypeId) {
        const filter: ICompanySyncstepFilter = {
            companysyncstepid: this.companySyncstep.id,
            id: 0,
            ignoresafetylimits: false,
            ignoresecurityfilteruntil: '',
            maxallowedadds: 0,
            maxalloweddeletes: 0,
            maxallowededits: 0,
            objecttypeid: objectTypeId,
        }
        return filter
    }

    public isChanged(): boolean {
        return this.filters().some(o => {
            const a = o.isAdded()
            const b = o.isEdited()
            const c = o.isDeleted()
            return a || b || c
        })
    }

    public getAdded(): ICompanySyncstepFilter[] {
        return this.filters()
            .filter(o => o.isAdded())
            .map(o => o.getSubmitData())
    }

    public getEdited(): ICompanySyncstepFilter[] {
        return this.filters()
            .filter(o => o.isEdited())
            .map(o => o.getSubmitData())
    }

    public getDeleted(): ICompanySyncstepFilter[] {
        return this.filters()
            .filter(o => o.isDeleted())
            .map(o => o.getSubmitData())
    }

    public isValid(): boolean {
        return this.filters().every(o => o.isValid())
    }

    public setCompanySyncstep(companySyncstep: ICompanySyncstep) {
        this.companySyncstep = companySyncstep
        this.filters().forEach(o => o.$original.companysyncstepid = this.companySyncstep.id)
    }

    public submitAll() {
        const created = this.getAdded()
        const updated = this.getEdited()
        const deleted = this.getDeleted().map(o => o.id)
        const bool = !![...created, ...updated, ...deleted].length

        const doNext = (arr: any[], method: (param: any) => Promise<any>): Promise<any> => {
            const val = arr.shift()
            if (!val) return Promise.resolve()
            return Promise.resolve()
                .then(() => method(val))
                .then(() => doNext(arr, method))
        }

        return Promise.resolve()
            .then(() => doNext(deleted, this.statusManager.do_deletecompanysyncstepfilter.bind(this.statusManager)))
            .then(() => doNext(created, this.statusManager.do_createcompanysyncstepfilter.bind(this.statusManager)))
            .then(() => doNext(updated, this.statusManager.do_updatecompanysyncstepfilter.bind(this.statusManager)))
            .then(() => bool)
    }

    dispose() {
        this.filters().forEach(o => o.dispose())
    }
}
